import React from 'react'
import ReactDOM from 'react-dom/client'
// libs
import { HelmetProvider } from 'react-helmet-async'
// components
import App from './App'
// utils
import { isRequestError } from 'utils/errors/normalize'
// css
import 'nprogress/nprogress.css'
import 'cropperjs/dist/cropper.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-sortable-tree/style.css'

// A failed request that nobody caught is not unhandled: the Apollo ErrorLink has already logged it
// and notified the user, so keep it from showing up again as "Uncaught (in promise)".
window.addEventListener('unhandledrejection', (event) => {
  if (isRequestError(event.reason)) {
    event.preventDefault()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
)
